import React from 'react';
import { Navigate } from 'react-router-dom';
import { getSession } from '../services/authSession';

// Protege rotas autenticadas: sem token na sessão, redireciona para o login.
function AuthGuard({ children }) {
  const session = getSession();

  if (!session?.token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AuthGuard;